import { render } from "./ViewToggle.vue?vue&type=template&id=15104bdd&scoped=true"
import script from "./ViewToggle.vue?vue&type=script&lang=js"
export * from "./ViewToggle.vue?vue&type=script&lang=js"

import "./ViewToggle.vue?vue&type=style&index=0&id=15104bdd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15104bdd"]])

export default __exports__